import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  return <section aria-labelledby="testimonios" className="bg-navy" data-id="element-161" data-mp="1n0aczfdwoovk">
      <div className="mx-auto max-w-page px-3 py-6 sm:px-6 sm:py-8" data-id="element-162" data-mp="1mxy1nl2nlcrh">
        <Reveal className="text-center" data-id="element-163" data-mp="1r0b3vzi6ysji">
          <h2 id="testimonios" className="font-display text-lg font-black uppercase leading-tight text-white sm:text-2xl lg:text-3xl" data-id="element-164" data-mp="1qz9ib13junnj">
            Lo que dicen quienes ya empezaron
          </h2>
          <p className="mt-1 text-[0.8rem] font-bold text-gold sm:text-[0.95rem]" data-id="element-165" data-mp="141ohcg15rpz1">
            De cero a comprender y utilizar las bases del inglés.
          </p>
        </Reveal>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2 lg:grid-cols-3" data-id="element-166" data-mp="2yfgxuthtgfgj">
          {testimonials.map((item, i) => <Reveal key={item.name} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-lg border border-gold/25 bg-navy-deep p-3" data-id="element-167" data-mp="32hat2m98sr9b" data-mpi={i}>
              <div className="flex items-center justify-between" data-id="element-168" data-mp="2q1gawx2jld50">
                <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-169" data-mp="34r4c7yaq4bsq">
                  {Array.from({
                length: 5
              }).map((_, s) => <StarIcon key={s} size={12} className="fill-gold text-gold" data-id="element-170" data-mp="2ztly7thun6dv" data-mpi={s} />)}
                </div>
                <QuoteIcon size={14} className="text-gold/40" aria-hidden="true" data-id="element-171" data-mp="2756o9ldkre9e" />
              </div>
              <p className="mt-1.5 text-[0.75rem] leading-snug text-ivory sm:text-[0.82rem]" data-id="element-172" data-mp="2h1jol23mkqd4">
                “{item.text}”
              </p>
              <div className="mt-auto pt-2" data-id="element-173" data-mp="1cru98bemap3">
                <p className="font-display text-[0.85rem] font-bold uppercase text-gold" data-id="element-174" data-mp="3shhuwy7f4yan">
                  {item.name}
                </p>
                <p className="text-[0.66rem] text-ivory sm:text-[0.72rem]" data-id="element-175" data-mp="3e92skr2ujay">
                  {item.role} · {item.place}
                </p>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}